import { Marketplace } from './';
import {JsonProperty} from 'json-typescript-mapper';

export class Additionalflat {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketplaceNumber')
  public marketplaceNumber?: string;

  @JsonProperty('validFrom')
  public validFrom?: string;

  @JsonProperty('priceType')
  public priceType?: string;

  @JsonProperty('priceSanitary')
  public priceSanitary?: number;

  @JsonProperty('priceCleaning')
  public priceCleaning?: number;

  @JsonProperty('priceParking')
  public priceParking?: number;

  @JsonProperty('priceVariable')
  public priceVariable?: number;

  @JsonProperty('priceAdministration')
  public priceAdministration?: number;

  @JsonProperty('priceDebit')
  public priceDebit?: number;

  @JsonProperty('priceModification')
  public priceModification?: number;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty({clazz: Marketplace, name: 'marketplace'})
  public marketplace?: Marketplace;

  constructor() {
    this.id =  void 0;
    this.marketplaceNumber =  void 0;
    this.validFrom =  void 0;
    this.priceType =  void 0;
    this.priceSanitary =  void 0;
    this.priceCleaning =  void 0;
    this.priceParking =  void 0;
    this.priceVariable = void 0;
    this.priceAdministration =  void 0;
    this.priceDebit =  void 0;
    this.priceModification =  void 0;
    this.updated =  void 0;
    this.created =  void 0;
    this.gguid =  void 0;
    this.marketplace =  void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/additionalflat.model.ts